<main class="bg-white position-relative">
  <div class="payoutt_container">
    <div class="container">
      <div class="row align-items-center">
        <div class="col-md-6 O-M-2">
          <div class="title_content">
            <h1 class="text-uppercase text-white open_sans font_68 bold_700">check out</h1>
            <p class="mt-lg-3 mt-xl-4 mt-2">On Payouttt, every sneaker you want is always available and
              authentic.</p>
            <div class="mt-lg-3 mt-xl-4">
              <a
                class="text-uppercase open_sans bold_700 text-white bg_green shop_btn d-inline-block font_16 mt-lg-2 mt-xl-3"
                routerLink="/categories-detail">Shop
                Now</a>
            </div>
          </div>
        </div>
        <div class="col-md-6 O-M-1 text-right">
          <img alt="" class="img-fluid" src="/assets/images/categories-shoes.png"/>
        </div>
        <div class="clearfix"></div>
      </div>
    </div>
  </div>

  <section class="padd-top-bot checkout-sec">
    <div class="container">
      <div class="row">
        <div class="col-md-6">
          <div class="checkout-left">
            <div class="return-customer">
              <a href="javascript:void(0);">Returning customer? <span>Click here to login</span></a>
            </div>
            <div class="billing-form">
              <h3>Billing Details</h3>
              <div class="billing-detail-sec">
                                    <span class="input input--yoshiko">
                                        <input class="input__field input__field--yoshiko" id="input-10" name="fname"
                                               required type="text" value="Smith John"/>
                                        <label class="input__label input__label--yoshiko" for="input-10">
                                            <span class="input__label-content input__label-content--yoshiko"
                                                  data-content="First Name">Your Name <sup>*</sup></span>
                                        </label>
                                    </span>
              </div>
              <div class="select_filed size-selected">
                <select aria-invalid="false" class="wpcf7-form-control wpcf7-select" class="Wide"
                        name="Selectbox">
                  <option value="Country">Country</option>
                  <option value="India">India</option>
                  <option value="Australia">Australia</option>
                </select>
              </div>
              <div class="billing-detail-sec">
                                    <span class="input input--yoshiko">
                                        <input class="input__field input__field--yoshiko" id="input-11" name="fname"
                                               required type="text"/>
                                        <label class="input__label input__label--yoshiko" for="input-11">
                                            <span class="input__label-content input__label-content--yoshiko"
                                                  data-content="First Name">Town / City <sup>*</sup></span>
                                        </label>
                                    </span>
              </div>
              <div class="billing-detail-sec">
                                    <span class="input input--yoshiko">
                                        <input class="input__field input__field--yoshiko" id="input-12" name="fname"
                                               required type="text"/>
                                        <label class="input__label input__label--yoshiko" for="input-12">
                                            <span class="input__label-content input__label-content--yoshiko"
                                                  data-content="First Name">Postcode / ZIP <sup>*</sup></span>
                                        </label>
                                    </span>
              </div>
              <div class="billing-detail-sec">
                                    <span class="input input--yoshiko">
                                        <input class="input__field input__field--yoshiko" id="input-13" name="fname"
                                               required type="text"/>
                                        <label class="input__label input__label--yoshiko" for="input-13">
                                            <span class="input__label-content input__label-content--yoshiko"
                                                  data-content="First Name">Street Address <sup>*</sup></span>
                                        </label>
                                    </span>
              </div>
              <div class="billing-detail-sec">
                                    <span class="input input--yoshiko">
                                        <input class="input__field input__field--yoshiko" id="input-14" name="fname"
                                               required type="text"/>
                                        <label class="input__label input__label--yoshiko" for="input-14">
                                            <span class="input__label-content input__label-content--yoshiko"
                                                  data-content="First Name">Phone <sup>*</sup></span>
                                        </label>
                                    </span>
              </div>
              <div class="billing-detail-sec">
                                    <span class="input input--yoshiko">
                                        <input class="input__field input__field--yoshiko" id="input-15" name="fname"
                                               required type="text"/>
                                        <label class="input__label input__label--yoshiko" for="input-15">
                                            <span class="input__label-content input__label-content--yoshiko"
                                                  data-content="First Name">Email Address <sup>*</sup></span>
                                        </label>
                                    </span>
              </div>
              <div class="custom-checkbox">
                <input id="account" type="checkbox">
                <label for="account">Create An Account</label>
              </div>
              <div class="billing-detail-sec billing-detail-textarea">
                                    <span class="input input--yoshiko">
                                        <textarea class="input__field input__field--yoshiko" id="input-145"
                                                  name="message">Notes about your order, e.g: special note for delivery
                                    </textarea>
                                        <label class="input__label input__label--yoshiko" for="input-14"> <span
                                          class="input__label-content input__label-content--yoshiko"
                                          data-content="Message">Order Notes</span> </label>
                                    </span>
              </div>
            </div>
          </div>
        </div>
        <div class="col-md-6">
          <div class="checkout-right-sec">
            <div class="order-table">
              <h2>Your Order</h2>
              <div class="table-body">
                <table>
                  <tbody>
                  <tr class="table-heading">
                    <td>Order</td>
                    <td>Total</td>
                  </tr>
                  <tr>
                    <td>Off-White x Wmns Air Zoom</td>
                    <td>$222.00</td>
                  </tr>
                  <tr>
                    <td>Off-White x Wmns Air Zoom</td>
                    <td>$222.00</td>
                  </tr>
                  <tr class="shipping">
                    <td>Shipping</td>
                    <td>Local Pickup (Free)</td>
                  </tr>
                  <tr class="sub-total">
                    <td>Subtotal</td>
                    <td>$444.00</td>
                  </tr>
                  <tr class="total">
                    <td>Total</td>
                    <td>$444.00</td>
                  </tr>
                  </tbody>
                </table>
              </div>
            </div>
            <div class="payment-summery">
              <h2>Payment</h2>
              <div class="accordion " id="accordion">
                <div class="card mb-0 payment-info-sec">
                  <div class="card-header collapsed payment-heading" data-toggle="collapse"
                       href="#collapseOne">
                    <img alt="" src="/assets/images/google-pay.png"/>
                    <h3>Google Pay</h3>
                    <i class="fa fa-angle-down"></i>
                  </div>
                  <div class="card-body collapse" data-parent="#accordion" id="collapseOne">
                    <p>Lorem Ipsum is simply dummy text of the printing and typesetting
                      industry. Lorem Ipsum has been the industry's standard dummy text ever
                      since the 1500s, when an unknown printer took a galley of type and
                      scrambled it to make a type specimen book.</p>
                  </div>
                  <div class="card-header collapsed payment-heading" data-parent="#accordion"
                       data-toggle="collapse" href="#collapseTwo">
                    <img alt="" src="/assets/images/paypal-img.png"/>
                    <h3>Paypal</h3>
                    <i class="fa fa-angle-down"></i>
                  </div>
                  <div class="card-body collapse" data-parent="#accordion" id="collapseTwo">
                    <p>Lorem Ipsum is simply dummy text of the printing and typesetting
                      industry. Lorem Ipsum has been the industry's standard dummy text ever
                      since the 1500s, when an unknown printer took a galley of type and
                      scrambled it to make a type specimen book.</p>
                  </div>
                  <div class="card-header collapsed payment-heading credit-sec"
                       data-parent="#accordion" data-toggle="collapse" href="#collapseThree">
                    <img alt="" class="credit-img" src="/assets/images/payment-img.png"/>
                    <h3>Credit Card</h3>
                    <i class="fa fa-angle-down"></i>
                  </div>
                  <div class="collapse card-body" data-parent="#accordion" id="collapseThree">
                    <p>Lorem Ipsum is simply dummy text of the printing and typesetting
                      industry. Lorem Ipsum has been the industry's standard dummy text ever
                      since the 1500s, when an unknown printer took a galley of type and
                      scrambled it to make a type specimen book.</p>
                  </div>
                  <div class="card-header collapsed payment-heading cash-delivery"
                       data-parent="#accordion" data-toggle="collapse" href="#collapsefour">
                    <h3>Cash On Delivery</h3>
                    <i class="fa fa-angle-down"></i>
                  </div>
                  <div class="collapse cash-delivery-detail" data-parent="#accordion"
                       id="collapsefour">
                    <p>Lorem Ipsum is simply dummy text of the printing and typesetting
                      industry. Lorem Ipsum has been the industry's standard dummy text ever
                      since the 1500s, when an unknown printer took a galley of type and
                      scrambled it to make a type specimen book.</p>
                  </div>
                </div>
              </div>
            </div>
            <div class="order-btn">
              <a routerLink="/confirmation">confirm order</a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>

</main>
